var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroBrowserCreateModalHeaderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_160_1",
    "data-name": "Component 160 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.43,
    height: 34.601,
    viewBox: "0 0 49.43 34.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(1.854 2.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M29,57H2.116A1.963,1.963,0,0,1,0,55.243V36.364A1.963,1.963,0,0,1,2.116,34.6H29a1.963,1.963,0,0,1,2.116,1.762V55.243A1.963,1.963,0,0,1,29,57Z",
    transform: "translate(0 -34.602)",
    fill: "#fff4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M269.172,34.6H255.728v22.4h13.444a1.963,1.963,0,0,0,2.116-1.762V36.365A1.963,1.963,0,0,0,269.172,34.6Z",
    transform: "translate(-240.168 -34.603)",
    fill: "#eee1dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M28.873,34.6H2.246A2.084,2.084,0,0,0,0,36.473v5.316H31.119V36.473A2.084,2.084,0,0,0,28.873,34.6Z",
    transform: "translate(0 -34.603)",
    fill: "#00337a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 0.975,
    cy: 0.812,
    rx: 0.975,
    ry: 0.812,
    transform: "translate(2.92 2.416)",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.975,
    cy: 0.812,
    rx: 0.975,
    ry: 0.812,
    transform: "translate(6.885 2.416)",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 0.975,
    cy: 0.812,
    rx: 0.975,
    ry: 0.812,
    transform: "translate(11.03 2.416)",
    fill: "#00ecce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M55.332,272.412a1.027,1.027,0,0,0-1.231.5l-.4.971-.458-1c0-.008-.009-.016-.013-.024s-.016-.031-.024-.046-.016-.024-.024-.036l-.022-.032c-.01-.013-.02-.025-.03-.037l-.023-.027-.034-.034-.027-.026-.035-.029-.033-.026-.036-.024-.039-.025-.038-.021-.041-.022-.046-.02-.038-.016-.066-.022-.02-.007h0a1.146,1.146,0,0,0-.189-.037h0c-.031,0-.062-.005-.093-.006h-.018c-.026,0-.051,0-.077,0l-.022,0c-.024,0-.048,0-.073.007l-.024,0q-.048.008-.095.02l-.064.017h0l-.034.012-.05.018-.046.021-.036.017-.046.026-.031.018-.042.029-.031.022-.035.029-.032.028-.028.029-.031.034-.023.029c-.01.012-.019.024-.028.037s-.014.022-.021.034-.015.024-.022.036-.015.031-.023.047-.008.016-.012.024l-.4.971-.458-1a1.038,1.038,0,0,0-1.251-.465.773.773,0,0,0-.559,1.042l1.412,3.071a.981.981,0,0,0,.9.518h.017a.97.97,0,0,0,.9-.544l.4-.971.458,1a.981.981,0,0,0,.9.518h.017a.97.97,0,0,0,.9-.544l1.268-3.071A.782.782,0,0,0,55.332,272.412Z",
    transform: "translate(-45.725 -260.324)",
    fill: "#192b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M201.6,272.412a1.027,1.027,0,0,0-1.231.5l-.4.971-.458-1c0-.008-.009-.016-.013-.024s-.016-.031-.025-.046-.016-.024-.023-.036-.014-.022-.022-.033-.02-.025-.03-.037l-.024-.028-.034-.034-.028-.027-.035-.029-.034-.027-.035-.024-.039-.025-.037-.02-.042-.022-.044-.019-.039-.016-.065-.022-.021-.007h0a1.137,1.137,0,0,0-.189-.037h0q-.046,0-.092-.006h-.018c-.026,0-.051,0-.077,0l-.022,0c-.024,0-.048,0-.073.007l-.029.005q-.045.007-.089.018l-.066.018h0l-.033.012-.051.019-.045.021-.037.017-.046.026-.032.019-.041.029-.031.023-.034.029-.032.028-.028.028-.031.034-.023.029c-.01.012-.019.024-.028.037s-.014.022-.021.034-.015.024-.022.036-.015.031-.023.047-.008.016-.012.024l-.4.971-.458-1a1.038,1.038,0,0,0-1.251-.465.773.773,0,0,0-.559,1.042l1.412,3.071a.981.981,0,0,0,.9.518h.017a.97.97,0,0,0,.9-.544l.4-.971.458,1a.981.981,0,0,0,.9.518h.017a.97.97,0,0,0,.9-.544l1.268-3.071A.783.783,0,0,0,201.6,272.412Z",
    transform: "translate(-183.096 -260.324)",
    fill: "#192b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M347.865,272.414a1.027,1.027,0,0,0-1.231.5l-.4.971-.458-1c0-.008-.008-.016-.013-.024s-.016-.031-.025-.046-.016-.024-.023-.036-.014-.022-.022-.033-.02-.025-.03-.037l-.024-.028-.034-.034-.028-.027-.035-.029-.034-.026-.035-.024-.039-.025-.037-.02-.042-.022-.044-.019-.039-.016-.065-.022-.021-.007h0a1.136,1.136,0,0,0-.189-.037h0c-.03,0-.061-.005-.092-.006h-.018c-.026,0-.051,0-.077,0l-.02,0c-.025,0-.049,0-.074.007l-.01,0c-.037.005-.074.013-.11.022l-.062.017h0l-.035.013-.049.018-.047.021-.035.017-.047.027-.031.018-.042.029-.03.022-.035.03-.031.028-.028.029-.031.033-.023.03c-.009.012-.019.024-.028.037s-.014.023-.021.034-.015.023-.022.036-.015.031-.023.047-.008.016-.012.024l-.4.971-.458-1a1.037,1.037,0,0,0-1.251-.465.773.773,0,0,0-.559,1.042l1.412,3.071a.981.981,0,0,0,.9.518h.017a.97.97,0,0,0,.9-.544l.4-.971.458,1a.981.981,0,0,0,.9.518h.017a.97.97,0,0,0,.9-.544l1.268-3.071A.782.782,0,0,0,347.865,272.414Z",
    transform: "translate(-320.459 -260.326)",
    fill: "#00215a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M269.042,34.6H255.728v7.186h15.56V36.473A2.084,2.084,0,0,0,269.042,34.6Z",
    transform: "translate(-240.168 -34.603)",
    fill: "#002659"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M258.675,272.415a1.027,1.027,0,0,0-1.231.5l-.4.971-.458-1c0-.008-.009-.016-.013-.024s-.016-.031-.025-.046-.016-.024-.023-.036l-.022-.033c-.01-.013-.02-.025-.03-.037l-.024-.028-.034-.034-.028-.027-.035-.029-.034-.026-.035-.024-.039-.025-.037-.02-.042-.022-.044-.019-.039-.016-.065-.022-.021-.007h0a1.138,1.138,0,0,0-.189-.037h0l-.073,0v3.169h0l.458,1a.981.981,0,0,0,.9.518h.017a.97.97,0,0,0,.9-.544l1.268-3.071A.782.782,0,0,0,258.675,272.415Z",
    transform: "translate(-240.168 -260.327)",
    fill: "#00215a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M0,160.543v1.613H31.119v-1.613Z",
    transform: "translate(0 -154.163)",
    fill: "#0089ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M255.728,160.543v1.613h15.56v-1.613Z",
    transform: "translate(-240.168 -154.163)",
    fill: "#295fcc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Asset-KuroDesktopIcon.d6ee1d2b1952bf5663a0c02e476b64b6",
    d: "M0,54.243v-17.3A4.943,4.943,0,0,1,4.943,32H29.658A4.945,4.945,0,0,1,34.6,36.943v17.3a4.948,4.948,0,0,1-4.943,4.943H22.1l1.645,4.943h4.673a1.236,1.236,0,0,1,0,2.471H6.179a1.236,1.236,0,1,1,0-2.471h4.673L12.5,59.186H4.943A4.945,4.945,0,0,1,0,54.243ZM29.658,34.471H4.943a2.472,2.472,0,0,0-2.471,2.471v17.3a2.47,2.47,0,0,0,2.471,2.471H29.658a2.469,2.469,0,0,0,2.471-2.471v-17.3A2.47,2.47,0,0,0,29.658,34.471ZM21.147,64.129,19.5,59.186H15.1l-1.645,4.943ZM41.4,55.479a1.854,1.854,0,1,1,1.854,1.854A1.849,1.849,0,0,1,41.4,55.479ZM37.072,35.707A3.708,3.708,0,0,1,40.78,32h4.943a3.708,3.708,0,0,1,3.707,3.707V62.894A3.708,3.708,0,0,1,45.722,66.6H40.78a3.708,3.708,0,0,1-3.707-3.707Zm2.471,0v3.707h7.414V35.707a1.237,1.237,0,0,0-1.236-1.236H40.78A1.237,1.237,0,0,0,39.544,35.707Zm0,6.179v2.471h7.414V41.886ZM40.78,64.129h4.943a1.239,1.239,0,0,0,1.236-1.236V46.829H39.544V62.894A1.239,1.239,0,0,0,40.78,64.129Z",
    transform: "translate(0 -32)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroBrowserCreateModalHeaderIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroBrowserCreateModalHeaderIcon.20fee811c402dae292b846a5affe5f01.svg";
export { ForwardRef as ReactComponent };